import { useParams } from "react-router-dom";
import YoutubeView from "./../components/YoutubeView.react";

export default function YoutubeViewRoute(): React$Element<any> {
  let params = useParams();
  return <YoutubeView sessionId={params.sessionId} />;
}
